var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNovisible(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_225_1051)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_225_1051)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.19298 8.43858C4.1701 8.19131 3.24111 7.8301 2.43177 7.41937L2.0931 8.77408L1.12295 8.53154L1.52786 6.91192C0.917189 6.53386 0.40245 6.13807 0 5.76543L0.679408 5.03167C2.9101 7.09712 9.061 10.0316 15.7028 5L16.3066 5.79709C15.6138 6.32196 14.9252 6.76622 14.2443 7.13848L14.761 8.69253L13.812 9.00803L13.3415 7.5928C12.2638 8.08887 11.2097 8.41037 10.1933 8.59262L10.409 10.5111L9.41531 10.6228L9.20229 8.72857C8.13841 8.82999 7.12341 8.78402 6.17479 8.63445L5.74826 10.3406L4.77811 10.098L5.19298 8.43858Z",
    fill: "#D91F05"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_225_1051"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_225_1051"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNovisible);
export default __webpack_public_path__ + "static/media/novisible.c4090926b43f285689c2713404e6afc2.svg";
export { ForwardRef as ReactComponent };